var HashMap = require("../collections/hashMap.js");
var InstanceBuilder = require("./instanceBuilder/instanceBuilder.js");
var AbstractInstance = require("./instanceBuilder/abstractInstance.js");

// Root extension to give each node in this root a deterministic locally unique id
var LocalUid = {
    initLocalUid: function(){
        var self = this;
        this.localIdMap = new HashMap();
        this.classIdx = {};

        this.onAdd("__setLuid", function(node){ // when a treenode is added to this root, give it a guid
            console.assert(node.constructor.$class, "Following tree node is added to this root without a defined class name", node);
            if (!this.localIdMap.contains(node.$localId)) {
                if (node instanceof AbstractInstance && !(node instanceof InstanceBuilder)) {
                    var builder = node.getBuilder();
                    var ancestorDepth = builder.ancestor().$id.split("/").length;
                    self.registerLocalId(node, builder.$localId + "/" + node.template().$localId.split("/").slice(ancestorDepth - 1).join("/"));
                } else this.registerLocalId(node, self.generateLuid(node.constructor.$class));
            }
        });

        this.onRemove("__removeLuid", function(node){
            this.localIdMap.remove(node.$localId);
            // delete node.$localId;
        });

        this.hasLocalUid = true;
    },

    registerLocalId: function(node, id){ // TODO: see if we can get rid of this
        node.$localId = id;
        this.localIdMap.put(id, node);
    },


    generateLuid: function(className){
        if (!this.classIdx[className]) this.classIdx[className] = 0;
        return className + "_" + this.classIdx[className]++;
    }
};

module.exports = LocalUid;